import React, { useState } from 'react';
import { Modal, Button, Form, Image, Row, Col, Spinner } from 'react-bootstrap';

interface UnsplashImage {
  id: string;
  urls: {
    small: string;
    full: string;
  };
}

interface ImageSelectorModalProps {
  entityName: string;
  onImageSelected?: (blob: Blob) => void;
}


const ImageSelectorModal: React.FC<ImageSelectorModalProps> = ({ entityName, onImageSelected }) => {
  const [show, setShow] = useState<boolean>(false);
  const [searchText, setSearchText] = useState<string>(entityName);
  const [images, setImages] = useState<UnsplashImage[]>([]);
  const [selectedImage, setSelectedImage] = useState<UnsplashImage | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectImageLoading, setSelectImageLoading] = useState<boolean>(false);

  const UNSPLASH_ACCESS_KEY = 'L9rD6Pe0_EEBYPhw848Kd7evDpaiwmOwTcPTwVM4-EI';

  const handleSearch = async () => {
    setLoading(true);
    try {
      const res = await fetch(
        `https://api.unsplash.com/search/photos?query=${encodeURIComponent(searchText)}&per_page=12&client_id=${UNSPLASH_ACCESS_KEY}`
      );
      const data = await res.json();
      setImages(data.results || []);
    } catch (err) {
      console.error('Unsplash search failed:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleSelect = async () => {
    if (!selectedImage) return;

    setSelectImageLoading(true);

    try {
      const response = await fetch(selectedImage.urls.full);
      const blob = await response.blob();

      if (onImageSelected) onImageSelected(blob);
    } catch (err) {
      console.error('Image fetch failed:', err);
    } finally {
      setSelectImageLoading(false);
      setShow(false);
    }
  };

  return (
    <>
      <Button variant="secondary" onClick={() => setShow(true)}>
        Search
      </Button>

      <Modal show={show} onHide={() => setShow(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Search Images</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Search Text</Form.Label>
            <Form.Control
              type="text"
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              placeholder="Enter search text"
            />
          </Form.Group>
          <Button variant="secondary" onClick={handleSearch} disabled={loading}>
            {loading ? 'Searching...' : 'Search'}
          </Button>

          <Row className="mt-3">
            {images.map((img) => (
              <Col xs={6} md={4} key={img.id} className="mb-3">
                <Image
                  src={img.urls.small}
                  thumbnail
                  onClick={() => setSelectedImage(img)}
                  style={{
                    border: selectedImage?.id === img.id ? '3px solid #007bff' : 'none',
                    cursor: 'pointer',
                  }}
                />
              </Col>
            ))}
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShow(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSelect} disabled={!selectedImage}>
            {selectImageLoading ? <Spinner animation="border" size="sm" /> : "Select"}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ImageSelectorModal;